import ModelWithFacilityApi from "./ModelWithFacilityApi";

export default class PowerSensorPointApi extends ModelWithFacilityApi {
	constructor(token, clientId, onUnauthorized) {
		super(token, clientId, onUnauthorized);
		this.baseUrl = this.getBaseUrl() + "metering/power_sensor_points/";
	}
}
